import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/image/logo.jpg'


const _hoisted_1 = { class: "loginView" }
const _hoisted_2 = { class: "loginBigBox" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "logoImg",
  referrerpolicy: "no-referrer",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "formBox" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "helolText" }, "欢迎登陆", -1)

import { ref } from 'vue';
import type {TabsPaneContext } from 'element-plus';
import password from '../components/loginCom/password.vue';
import codeCheck from '../components/loginCom/codeCheck.vue';
import Api from '@/api';

//获取应用是否可用

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const getListFn = async () => {
    const result = await Api.Application.getList();
};

getListFn();

const activeName = ref('code');
const handleClick = (tab: TabsPaneContext, event: Event) => { };
const checked1 =ref(false);



return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_el_tabs, {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (activeName.value = $event)),
          stretch: "true",
          class: "demo-tabs",
          onTabClick: handleClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "验证码",
              name: "code"
            }, {
              default: _withCtx(() => [
                _createVNode(codeCheck)
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "密码",
              name: "password"
            }, {
              default: _withCtx(() => [
                _createVNode(password)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})